/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgSpecAdminDelete
 */
export interface OrgSpecAdminDelete {
    /**
     * 
     * @type {string}
     * @memberof OrgSpecAdminDelete
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecAdminDelete
     */
    org_spec_azure_id: string;
}

/**
 * Check if a given object implements the OrgSpecAdminDelete interface.
 */
export function instanceOfOrgSpecAdminDelete(value: object): value is OrgSpecAdminDelete {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('org_spec_azure_id' in value) || value['org_spec_azure_id'] === undefined) return false;
    return true;
}

export function OrgSpecAdminDeleteFromJSON(json: any): OrgSpecAdminDelete {
    return OrgSpecAdminDeleteFromJSONTyped(json, false);
}

export function OrgSpecAdminDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgSpecAdminDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'org_spec_azure_id': json['org_spec_azure_id'],
    };
}

export function OrgSpecAdminDeleteToJSON(json: any): OrgSpecAdminDelete {
    return OrgSpecAdminDeleteToJSONTyped(json, false);
}

export function OrgSpecAdminDeleteToJSONTyped(value?: OrgSpecAdminDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'org_spec_azure_id': value['org_spec_azure_id'],
    };
}

